var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-content-end"},[_c('b-button',{staticClass:"border-0 py-1 px-2",attrs:{"variant":"outline-primary"},on:{"click":_setup.startTour}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":['fa', 'info']}}),_vm._v(" "+_vm._s(_vm.buttonText)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }